<section class="quick-facts">
    <h2>Fatos rápidos sobre o Dia de Doar</h2>
    <p>O Dia de Doar faz parte de um crescente movimento global de incentivo à generosidade que impulsiona doações e
        ações coletivas em comunidades ao redor do mundo.</p>
    <p>
        O Dia de Doar faz parte do GivingTuesday, movimento criado em 2012 com uma ideia simples: um dia que incentiva
        as pessoas a fazerem o bem. Nos últimos treze anos, essa ideia se transformou em um movimento global que inspira
        centenas de milhões de pessoas a doar, colaborar e celebrar a generosidade o ano todo.
    </p>

    <p>
        O GivingTuesday inspira generosidade em todo o mundo através de uma rede distribuída de líderes. Existem
        movimentos nacionais oficiais do GivingTuesday em mais de 100 países, liderados por uma rede global de líderes
        empreendedores apaixonados. Em nível de base, pessoas e organizações participam do GivingTuesday em todos os
        países do mundo.
    </p>
    <p>
        O Dia de Doar cria um impacto global impulsionado pela ação local. Somente no Brasil, em 2024 foram 80 campanhas
        comunitárias que reúnem milhares de organizações sem fins lucrativos, fundações, organizações de base, pequenas
        empresas e indivíduos generosos para doar. Por meio do #DiadeDoarKids, os jovens estão liderando mudanças e
        inspirando ações em todo o mundo.
    </p>
    <img src="assets/hero/about-hero.png" alt="picture">
    <p>Em 2024, com 177 publicações no Instagram, 15 no LinkedIn, 24 matérias no site e 895 matérias na imprensa, a
        iniciativa alcançou uma equivalência publicitária estimada em R$ 74 milhões. O Programa de Dados registrou mais
        de R$ 5 milhões em doações mapeadas por 16 plataformas parceiras, como Benfeitoria, Catarse, Arredondar, iFood,
        Doare, entre outras, além da colaboração com o GivingTuesday.Com
    </p>
    <p>
        O Dia de Doar é um centro de conhecimento, aprendizado e, por fim, inovação em torno da generosidade. Nosso
        Programa de Dados trabalha junto com grande parte das plataformas de transação de doação brasileira, para
        entender os motivadores e impactos da generosidade, explorar comportamentos e padrões de doação e usar dados
        para inspirar mais doações em todo o mundo. Junto com o GivingTuesday Data Commons, são mais de 300 parceiros
        contribuintes e 50 laboratórios de dados globais, a iniciativa é a maior colaboração filantrópica de dados já
        criada.

    </p>
    <p>
        As pessoas podem mostrar sua generosidade de várias maneiras durante o Dia de Doar. Seja ajudando um vizinho,
        buscando doações para resolver um problema pontual, compartilhando uma habilidade ou encontrando oportunidades
        virtuais de voluntariado com suas causas favoritas - todos têm algo a oferecer e toda doação conta.
    </p>
</section>